import { render } from "./EditAbout.vue?vue&type=template&id=7fd3f3ea&scoped=true"
import script from "./EditAbout.vue?vue&type=script&lang=js"
export * from "./EditAbout.vue?vue&type=script&lang=js"

import "./EditAbout.vue?vue&type=style&index=0&id=7fd3f3ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd3f3ea"]])

export default __exports__